import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import SystemIcon from '../ShortStatus/SystemIcon';
import Button from '../../../components/CustomButtons/ButtonTS';
import CancelIcon from '@material-ui/icons/Cancel';
import Card from '../../../components/Card/CardTS';
import CardBody from '../../../components/Card/CardBody';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardIcon from '../../../components/Card/CardIcon';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { closeSweetAlertStyle } from '../../helpers/CustomStyles';
import utils from '../../helpers/GlobalVariables';
import { closeDeleteMapNotification, deleteMapFile } from '../../stores/actions/installerActions';
import Snackbar from '../../../components/Snackbar/Snackbar';
import Loading from '../Loading/Loading';
import Map from "@material-ui/icons/Map";

interface DeleteMapProps {
	systemId: number;
    systemName: string;
    systemUpdatedViaWebsiteAt: string;
    mapType: string;
	deleteMapSucceeded: boolean;
	deleteMapFailed: boolean;
	mobileView: boolean;
	hideAlert: () => void;
	deleteMapFile: (systemId: number, mapType: string) => void;
	closeDeleteMapNotification: () => void;
}

const closeButtonStyle = {
	border: '1px solid #00acc1',
};

const DeleteMap = ({
	systemId,
    mapType,
	deleteMapSucceeded,
	deleteMapFailed,
	mobileView,
	hideAlert,
    deleteMapFile,
	closeDeleteMapNotification,
}: DeleteMapProps) => {
	const [popupTimeoutEnabled, setPopupTimeoutEnabled] = useState(false);
	const [isLoaderRender, setIsLoaderRender] = useState(false);
	useEffect(() => {
		closeDeleteMapNotification();
	}, [closeDeleteMapNotification]);

	useEffect(() => {
		if (deleteMapSucceeded) {
			setPopupTimeoutEnabled(true);
		}
		if (deleteMapSucceeded || deleteMapFailed) {
            setIsLoaderRender(false);
			const timeoutNotification = setTimeout(() => {
				closeDeleteMapNotification();
			}, 6000);
			return () => {
				clearTimeout(timeoutNotification);
			};
		}
	}, [closeDeleteMapNotification, deleteMapSucceeded, deleteMapFailed]);

	useEffect(() => {
		if (popupTimeoutEnabled) {
			const closeWindowTimeout = setTimeout(() => {
				setPopupTimeoutEnabled(false);
				hideAlert();
			}, 6000);
			return () => {
				clearTimeout(closeWindowTimeout);
			};
		}
	}, [popupTimeoutEnabled, hideAlert]);

	const closeButtonHover = (e) => {
		const button = e.target;
		button.style.backgroundColor = 'rgba(0, 172, 193, 0.1)';
	};

	const closeButtonLeave = (e) => {
		const button = e.target;
		button.style.backgroundColor = '#ffffff';
	};

	const handleDeleteMap = () => {
        setIsLoaderRender(true);
        deleteMapFile(systemId, mapType);
	};

	const handleCloseNotification = () => {
		setIsLoaderRender(false);
		closeDeleteMapNotification();
	};

	const renderDesktopNotifications = (): JSX.Element => {
		if (mobileView) return null;

		const color = deleteMapSucceeded ? 'success' : 'danger';
		const message = deleteMapSucceeded
			? 'Map was deleted successfully.'
			: 'Map was not deleted.';
		const isOpen = deleteMapSucceeded || deleteMapFailed ? true : false;
		return (
			<Snackbar
				close={true}
				closeNotification={handleCloseNotification}
				color={color}
				message={message}
				open={isOpen}
				place='tc'
			/>
		);
	};

	const renderMobileNotifications = () => {
		const headerStyle = utils.getHeaderStyle(deleteMapFailed);
		if (!mobileView) return null;
		if (deleteMapFailed || deleteMapSucceeded) {
			return (
				<GridItem xs={12}>
					<h5
						className={deleteMapFailed ? 'notification-open-create-system-fail' : 'notification-open-create-system-success'}
						style={headerStyle}
					>
						{deleteMapFailed
							? 'Map was not deleted.'
							: 'Map was deleted successfully.'}
					</h5>
				</GridItem>
			);
		}
	};

	const handleRemoveButtonClicked = () => {
		setIsLoaderRender(true);
		handleDeleteMap();
	};

	return (
		<div>
			<GridContainer>
				<GridItem xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button
						data-testid='cancelButton'
						simple
						justIcon
						color='info'
						style={closeSweetAlertStyle}
						onClick={hideAlert}
					>
						<CancelIcon style={{ width: '20px', height: '20px' }} />
					</Button>
				</GridItem>
			</GridContainer>
			<Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} className='node-edit-card'>
				<CardHeader color='info' icon>
					<CardIcon color='info'>
						<Map />
					</CardIcon>
					{/* <h3 style={utils.sweetAlertHeaderStyle} className='remove-system-header'>
						{systemName}
					</h3> */}
                    <h4 style={utils.sweetAlertHeaderStyle} className='remove-system-header'>
						{ mapType == 'second' && 'Second map' || 'Third map' }
					</h4>
				</CardHeader>
				<CardBody>
					<GridContainer>
						<GridItem xs={12}>
							<h5>This operation is irreversible.<br />Are you sure you want to delete this map?</h5>
						</GridItem>
						{renderMobileNotifications()}
						<GridItem xs={12} style={{ margin: '15px 0 0 0 ' }}>
							<div style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
								<Button
									className='deleteMapCloseButton'
									simple
									color='info'
									style={closeButtonStyle}
									onClick={hideAlert}
									onMouseEnter={(e) => closeButtonHover(e)}
									onMouseLeave={(e) => closeButtonLeave(e)}
								>
									cancel
								</Button>
								<Button
									style={{ backgroundColor: isLoaderRender ? '#ccc' : '#f44336' }}
									onClick={handleRemoveButtonClicked}
									disabled={isLoaderRender}
								>
									{isLoaderRender ? <Loading transform={1} height={17} width={48} color='darkGray' /> : 'remove'}
								</Button>
							</div>
						</GridItem>
					</GridContainer>
				</CardBody>
			</Card>
			{renderDesktopNotifications()}
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		systems: state.dashboard.systems,
		deleteMapSucceeded: state.installer.deleteMapSucceeded,
		deleteMapFailed: state.installer.deleteMapFailed,
		mobileView: state.dashboard.mobileView,
	};
};

const actions = {
	closeDeleteMapNotification,
    deleteMapFile
};

export default connect(mapStateToProps, actions)(DeleteMap);
